// SPDX-License-Identifier: AGPL-3.0-or-later

import type {ContextMenuCommand} from '@app/features/devtools/state/ApplicationCommandsStore';
import {http} from '@app/features/platform/transport/RestTransport';

interface RunContextCommandParams {
	command: ContextMenuCommand;
	guildId: string;
	channelId: string;
	targetId: string;
}

// Runs a user or message command from the context menu. The bot answers through the interaction callback.
export async function runContextCommand({
	command,
	guildId,
	channelId,
	targetId,
}: RunContextCommandParams): Promise<void> {
	await http.post('/interactions', {
		body: {
			type: 2,
			application_id: command.applicationId,
			guild_id: guildId,
			channel_id: channelId,
			data: {
				id: command.commandId,
				name: command.name,
				type: command.commandType,
				target_id: targetId,
			},
		},
	});
}
